import { User, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Product } from "@/types/product";
import { useTranslation } from "react-i18next";

interface ProductHeaderProps {
  product: Product;
}

const ProductHeader = ({ product }: ProductHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <h1 className="text-3xl font-bold">{product.name}</h1>
      <p className="text-lg text-muted-foreground">{product.brand}</p>
      
      <div className="flex items-center gap-2 mt-2">
        {product.user_id && (
          <Button
            variant="ghost"
            size="sm"
            className="flex items-center gap-1"
            onClick={() => navigate(`/user/${product.user_id}`)}
          >
            <User className="w-4 h-4" />
          </Button>
        )}
        
        <div className="flex items-center">
          <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
          <span className="font-medium ml-1">{product.rating || 0}</span>
          <span className="text-muted-foreground ml-1">
            ({product.reviews_count || 0} {t('products.reviews')})
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProductHeader;